import { Box } from "@mui/material";

import { useEffect, useState } from "react";

import PolicyUpdateForm from "./form";
import { HRService } from "../../../../config";
import {
  AllPoliciesColumns,
  LeaveApproversColumns,
  imprestApplicationsColumns,
  requisitionApproversColumns,
} from "../../../../data/Columns/hrmanagement";
import {
  LeaveApprovers,
  allPolicies,
  imprestApplications,
  requisitionApprovers,
} from "../../../../data/Queries/HRmanagement/leavemanagement";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import ApproversForm from "./form";
import ImprestApproversForm from "./form";

const base_url = HRService.uri;
const actions = {
  entity: "Leave Approvers",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  removeLeaveApprover: {
    key: "REMOVE_RELIEVER",
    button_name: "Remove Approver",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  dataObject: {
    inputObjectName :"addRemoveRequisitionApprover"
      
   
  },
  showStatus: true,
};
function ImprestApproversTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Imprest Approvers"
          subtitle="View all Imprest approvers , add and remove"
          columns={requisitionApproversColumns}
          FormComponent={ImprestApproversForm}
          actions={actions}
          query={requisitionApprovers}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default ImprestApproversTable;
